import { useEffect } from "react";
import ReactGA from "react-ga4";

const GoogleAnalytics = () => {
  useEffect(() => {
    ReactGA.initialize("G-134D517X84"); 
    ReactGA.send("pageview");
  }, []);

  return null;
};

export default GoogleAnalytics;
